// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-create-new-tsx": () => import("./../../../src/pages/createNew.tsx" /* webpackChunkName: "component---src-pages-create-new-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-invoice-tsx": () => import("./../../../src/templates/invoice.tsx" /* webpackChunkName: "component---src-templates-invoice-tsx" */)
}

